import { z } from "zod";
import { ERPProviderKeySchema } from "../erpIntegrations/schemas";

export const ExternalMappingEntityTypeSchema = z.enum([
  "company",
  "person",
  "quote",
  "item",
  "operation",
  "opportunity",
  "note",
  "attachment",
  "priceList",
  "location",
  "shippingAddress",
  "inventoryLine",
]);

export type ExternalMappingEntityType = z.infer<
  typeof ExternalMappingEntityTypeSchema
>;

export const EXTERNAL_MAPPING_ENTITY_TYPE =
  ExternalMappingEntityTypeSchema.enum;

const JsonRecordSchema = z.record(z.string(), z.unknown());

export const ExternalMappingSchema = z.object({
  id: z.string(),
  syncId: z.string(),
  providerId: ERPProviderKeySchema,
  entityType: ExternalMappingEntityTypeSchema,
  entityId: z.string(),
  externalId: z.string(),
  externalMetadata: JsonRecordSchema.nullish(),
  sourceHash: z.string().nullish(),
  syncedAt: z.coerce.date(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ExternalMapping = z.infer<typeof ExternalMappingSchema>;
